import { Component, OnInit, Input, AfterViewInit } from '@angular/core'
import * as $ from 'jquery';
import { AjaxService } from 'src/app/shared/ajax.service'
import { CmodalModel } from './cmodal.model'
import { CmodalService } from './cmodal.service'

@Component({
  selector: 'app-cmodal',
  templateUrl: './cmodal.component.html'
})
export class CmodalComponent implements OnInit, AfterViewInit {
  @Input() model: CmodalModel

  constructor(public service: CmodalService, private ajax: AjaxService) { }

  ngOnInit() {
    

  }

  ngAfterViewInit(): void {

  }

  ExecutePartial = function (option) {
    this.Open();
    this.onclosed = null;
    if (option.befor != undefined) option.befor();
    if (option.onclosed != undefined) this.onclosed = option.onclosed;
    if (option.width != undefined) this.modal.find('.modal-dialog').css('width', option.width);
    this.header.find('.loading').show();
    this.title.html(option.title);
    this.descript.html(option.descript == undefined ? '' : option.descript);
    option.alertPad = { pad: 'toastr', mode: 'text', display: 'inline-block' },
      option.success = function () {
        var masterHeader = '';
        if (option.masterHeader) {
          for (var i = 0; i < option.masterHeader.length; i++)
            masterHeader += '<strong>' + option.masterHeader[i][0] + '</strong> : &nbsp;<span>' + option.masterHeader[i][1] + '</span> &nbsp; &nbsp; &nbsp;';

          this.masterHeader = masterHeader
        }
      }
    option.complete = function () {
      this.header.find('.loading').hide();
    }

    this.ajax.execute(option);
  }

  
}
